import { useEffect, useState } from 'react';

import { ICartEntry } from '@rbi-ctg/menu';
import { useDayPartContext } from 'state/day-part';
import { IDayPartBoundary } from 'state/day-part/hooks/use-active-day-parts';
import { IMenuItem, getMenuItemDayParts } from 'utils/availability';

import { useCartEntriesMenuObjects } from './use-cart-entries-menu-objects';

/**
 * Iterates over menu items and picks unique day parts
 */
const getAllMenuItemDayParts = (menuItems: IMenuItem[]) =>
  menuItems.reduce((acc: string[], menuItem) => {
    const menuItemDayParts = getMenuItemDayParts(menuItem);
    return acc.concat(menuItemDayParts.filter(dayPart => !acc.includes(dayPart)));
  }, []);

export const useCartEntriesDayParts = (cartEntries: ICartEntry[] | undefined) => {
  const { activeDayParts } = useDayPartContext();
  const { getCartEntriesMenuObjects } = useCartEntriesMenuObjects();

  const [isLoading, setIsLoading] = useState(true);
  const [cartEntriesDayParts, setCartEntriesDayParts] = useState<string[]>([]);
  const [cartEntriesActiveDayParts, setCartEntriesActiveDayParts] = useState<IDayPartBoundary[]>(
    []
  );

  useEffect(() => {
    if (!cartEntries) {
      return;
    }

    const fetchData = async () => {
      const data = await getCartEntriesMenuObjects(cartEntries);
      const menuItemsDayParts = getAllMenuItemDayParts(data.map(entry => entry.data));
      setCartEntriesDayParts(menuItemsDayParts);

      const menuItemsActiveDayParts = activeDayParts.filter(dayPart =>
        menuItemsDayParts.includes(dayPart.key.toLowerCase())
      );

      setCartEntriesActiveDayParts(menuItemsActiveDayParts);
      setIsLoading(false);
    };

    fetchData();
  }, [activeDayParts, cartEntries, getCartEntriesMenuObjects]);

  return {
    cartEntriesDayParts,
    cartEntriesActiveDayParts,
    isLoading,
  };
};
